<template>
 <a-col :sm="8" :xs="24" class="mb-25">
  <a-form-item label="Handtekening op akkoordpagina" name="eSignatureType"
               extra="Geldt ook voor openstaande offertes. Reeds geaccordeerde orders blijven ongewijzigd.">
   <a-select :value="form.eSignatureType" :disabled="!canUpdate" :allowClear="false"
             class="sDash_fullwidth-select" placeholder="Selecteer een optie" size="large"
             @change="$emit('change', $event)">
    <a-select-option value="WET">Ja, handtekening tekenen</a-select-option>
    <a-select-option value="NONE">Nee, alleen accorderen</a-select-option>
   </a-select>
  </a-form-item>
 </a-col>
</template>

<script>
export default {
 name: 'ProductSignatureField',
 emits: ['change'],
 props: {
  form: {type: Object, required: true},
  canUpdate: {type: Boolean, default: false},
 },
};
</script>
